










































































































import { Component, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";
import Context from "@/mixins/context";

// Enums/Data
import { QUERY_PARAMS } from "@/data/constants";

@Component({
  components: {
    "terms-and-conditions-statement": () =>
      import("@/components/app/global/auth/termsAndConditionsStatement.vue")
  }
})
export default class OrganisationRegistrationForm extends Mixins(
  RequestPromises,
  HasValidation,
  Context
) {
  // Refs

  public declare $refs: {
    recaptcha: any;
    observer: InstanceType<typeof ValidationObserver>;
  };

  // Variables

  public form: {
    orgname: string;
    name: string;
    email: string;
    password: string;
    recaptcha_token: string;
    order_template_code?: string;
  } = {
    orgname: "",
    name: "",
    email: "",
    password: "",
    recaptcha_token: ""
  };
  public isProcessing = false;
  public isSuccess = false;

  // Methods

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this.createAccount();

      this.isSuccess = true;
      this.$buefy.toast.open({
        message: this.$t("_sentence.registration_successful") as string
      });
    } catch (error) {
      // Regenerate reCaptcha token for subsequent attempt
      await this.$refs.recaptcha.generateToken();
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public createAccount() {
    const form = this.$_.clone(this.form);

    if (this.orderTemplateCode) {
      form.order_template_code = this.orderTemplateCode;
    }

    return this.$store.dispatch("auth/admin/register", form);
  }

  // Computed

  public get disableSubmitButton() {
    if (!this.hasErrors) {
      return false;
    }
    if (this.hasError("recaptcha_token")) {
      let hasErrors = false;
      this.$_.forEach(this.validationErrors, (error, key) => {
        if (key === "recaptcha_token") {
          return;
        }
        hasErrors = error.length !== 0;
        if (hasErrors) {
          return false;
        }
      });
      return hasErrors;
    }
    return true;
  }

  public get orderTemplateCode() {
    return this.$_.get(
      this.$route,
      `query.${QUERY_PARAMS.ORDER_TEMPLATE_CODE}`,
      ""
    );
  }
}
